import React from "react";
import { useHistory } from "react-router-dom";
import { Api } from "../../../../services/api";
import { Team } from "../../../../services/api/types/Teams";
import { TeamForm } from "../TeamForm";
import { TeamFormHeader, TeamFormType } from "../TeamForm/teamFormSchema";
import { TeamStatus } from "../../../../enums";
import {
  selectMemberMap,
  selectTeamTypeMap,
  useAppDispatch,
} from "../../../../store/hooks";
import { setMembers } from "../../../../store/slices/MemberListSlice";
import { ColumnContainer } from "../../Admin.styles";
import axios from "axios";
import { FormikHelpers } from "formik";

export const AddTeamForm: React.FC<{}> = () => {
  const history = useHistory();
  const dispatch = useAppDispatch();

  const members = selectMemberMap();
  const teamTypes = selectTeamTypeMap();

  const submitValues = (
    values: TeamFormType,
    { setErrors }: FormikHelpers<TeamFormType>
  ) => {
    const teamType = teamTypes.get(values.team as string);
    const teamLeader = members.get(values.lead as string);

    const data: Team = {
      status: TeamStatus.ACTIVE, //Default to active
      nickname: values.nickName || "",
      teamTypeId: teamType ? teamType.id : "",
      teamLeaderId: teamLeader ? teamLeader.id : undefined,
    };
    Api.teams
      .createTeam(data)
      .then(res => {
        //update members now that one has been changed to team
        Api.members
          .getMembers()
          .then(res => {
            dispatch(setMembers(res.data));
          })
          .catch(() => {
            dispatch(setMembers([]));
          });
        const currentLocation = history.location;
        currentLocation.pathname =
          currentLocation.pathname.split("/").slice(0, -1).join("/") +
          `/${res.data.id}/edit`;
        history.push(currentLocation);
      })
      .catch((error: Error) => {
        if (
          axios.isAxiosError(error) &&
          error.response &&
          error.response.data.detail ===
            "Team with this nickname already exists"
        ) {
          setErrors({ nickName: "Name already used" });
        } else {
          console.error("Create Office", error);
        }
      });
  };

  return (
    <ColumnContainer>
      <TeamForm header={TeamFormHeader.add} submitValues={submitValues} />
    </ColumnContainer>
  );
};
